/**
 * AMO Batch 01 — cosmetic wiring only.
 *
 * The selected look is 100% CSS (:has(:checked)); this script never shows/hides
 * or toggles classes. It only mirrors the chosen radio into a line-item property
 * on the add-to-cart form and updates the running total. It binds ONE listener on
 * document, so it survives any Theme Editor re-render without rebinding.
 */
(function () {
  if (window.__amoBatch01Init) return;
  window.__amoBatch01Init = true;

  function variantMap() {
    const el = document.querySelector('[data-amo-variants]');
    if (!el) return null;
    try {
      const list = JSON.parse(el.textContent);
      if (!Array.isArray(list)) return null;
      const m = {};
      list.forEach((v) => { m[String(v.id)] = v.price; });
      return m;
    } catch (e) {
      return null;
    }
  }

  function money(fmt, cents) {
    const amount = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function findForm(block) {
    const scope = block.closest('.shopify-section, dialog') || document;
    return (
      scope.querySelector('form[data-type="add-to-cart-form"]') ||
      scope.querySelector('form[action^="/cart/add"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]')
    );
  }

  function setProp(form, name, value) {
    if (!form) return;
    const fieldName = 'properties[' + name + ']';
    let input = form.querySelector('input[name="' + CSS.escape(fieldName) + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = fieldName;
      form.appendChild(input);
    }
    input.value = value;
  }

  function basePrice(block) {
    let cents = parseInt(block.dataset.basePrice || '0', 10);
    const map = variantMap();
    const form = findForm(block);
    const idInput = form && form.querySelector('input[name="id"]');
    if (map && idInput && typeof map[String(idInput.value)] === 'number') {
      cents = map[String(idInput.value)];
    }
    return cents;
  }

  function apply(block) {
    if (!block) return;
    const radio = block.querySelector('input.ab1__radio:checked');
    const form = findForm(block);
    const surcharge = radio ? parseInt(radio.dataset.surcharge || '0', 10) : 0;
    if (radio) {
      setProp(form, block.dataset.prop || 'Delivery', radio.value);
      // Hidden "min|max|property|feeVariant": lets the cart page re-date the batch from
      // the day the customer actually checks out (main-cart.liquid).
      setProp(form, '_batch', radio.dataset.batch || '');
    }
    const total = block.querySelector('[data-amo-batch-total]');
    if (total) total.textContent = money(block.dataset.moneyFormat, basePrice(block) + surcharge);
  }

  function applyAll() {
    document.querySelectorAll('.ab1').forEach(apply);
  }

  // One delegated change listener for the life of the page.
  document.addEventListener('change', function (e) {
    const t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('.ab1 input.ab1__radio')) {
      apply(t.closest('.ab1'));
    } else if (t.matches('input[name="id"]')) {
      applyAll();
    }
  });

  if (document.readyState !== 'loading') applyAll();
  else document.addEventListener('DOMContentLoaded', applyAll);
  // Re-sync after a Theme Editor section re-render.
  document.addEventListener('shopify:section:load', applyAll);
})();
